import { LoadingButton } from '@mui/lab'
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material'
import { defaultModalStyle, defaultModalZIndex, minButtonWidth } from 'const'
import React, { useState } from 'react'

type PortalType = 'trainee' | 'caregiver'

export function DuplicateCourseModal({
  courseName,
  loading,
  handleClose,
  handleConfirm,
}: {
  courseName: string
  loading: boolean
  handleClose: () => void
  handleConfirm: (portal: PortalType) => void
}) {
  const [portal, setPortal] = useState<PortalType>('trainee')

  return (
    <Modal sx={defaultModalZIndex} open={true}>
      <Box sx={{ ...defaultModalStyle, width: 420 }}>
        <Typography variant="h5" mb={3}>
          Duplicate Course
        </Typography>
        <Typography variant="body1">
          You are trying to duplicate
          <br />
          <i>&ldquo;{courseName}&rdquo;</i>
        </Typography>
        <Typography variant="body1" mt={3} mb={1}>
          Select portal type:
        </Typography>
        <FormControl>
          <RadioGroup value={portal} onChange={(e) => setPortal(e.target.value as PortalType)}>
            <FormControlLabel value="trainee" control={<Radio />} label="Trainee" />
            <FormControlLabel value="caregiver" control={<Radio />} label="Family" />
          </RadioGroup>
        </FormControl>
        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
          <Button variant="outlined" onClick={handleClose} sx={minButtonWidth}>
            Close
          </Button>
          <LoadingButton
            loading={loading}
            variant="contained"
            onClick={() => handleConfirm(portal)}
            sx={minButtonWidth}
          >
            Confirm
          </LoadingButton>
        </Stack>
      </Box>
    </Modal>
  )
}
